import React, { Component, useContext } from "react";
import { Helmet } from "react-helmet";
import {} from "react-bootstrap";
import PageTitle from "../../common/PageTitle";
import { getTermsAndConditions } from "../../common/TermsAndConditions";

class TermsAndConditionsPage extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Turgoil - Kasutustingimused</title>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, user-scalable=no"
          />
        </Helmet>
        <PageTitle>Kasutustingimused</PageTitle>
        <div>{getTermsAndConditions()}</div>
      </>
    );
  }
}

export default TermsAndConditionsPage;
